module.exports = __webpack_public_path__ + "static/media/feat-barons-hero.7d668850.jpg";